import { Product } from '@flippingbook/web.utils/dist/ProductsList';
import { useMemo } from 'react';
import type { To } from 'react-router-dom';

import { loc } from '@/localization';
import { Link } from '@/site/components/Link';

import { e } from './style.css';

export function PublisherTeaser({ productLink }: { productLink: (product: Product) => To }) {
    const href = useMemo(() => productLink(Product.FBOnline), [productLink]);

    return (
        <div className={e.publisherTeaser}>
            <div className={e.publisherTeaserContent}>
                {loc.Registration.PublisherTeaserText}{' '}
                <Link
                    to={href}
                    color="inhreit"
                    reloadDocument
                >
                    {loc.Registration.PublisherTeaserButtonText}
                </Link>
            </div>
        </div>
    );
}
